import loadable from '@loadable/component'
import Loading from 'components/Loading/Loading'
import { timeout } from 'promise-timeout'
import React from 'react'
import { TIMEOUT_LOADER } from 'utils/globals'

const RegionalListECPF = loadable(
  () => timeout(import(
    /* webpackChunkName: "RegionalECPF" */
    'ecpf/app/RegionalECPF/views/RegionalListECPF/RegionalListECPF'
  ), TIMEOUT_LOADER),
  {
    fallback: <Loading/>
  }
)

export { RegionalListECPF }
